@use "variables" as *;

.connection {
  margin: $spacing-1 0;
  text-align: left;
}
